import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RenderIn, device } from '../../utils/RenderIn';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import styles from './HpSharedModuleContainer.scss';

function HpSharedModuleHeader({ children }) {
    return children ? (
        <Fragment>
            <RenderIn deviceTypes={[device.DESKTOP, device.TABLET]}>
                <BarHeader title={children} size="xLarge" htmlElementType="h2" />
            </RenderIn>
            <RenderIn deviceTypes={[device.MOBILE]}>
                <BarHeader title={children} htmlElementType="h2" />
            </RenderIn>
        </Fragment>
    ) : null;
}

HpSharedModuleHeader.propTypes = {
    children: PropTypes.node,
};

function HpSharedModuleSubHeader({ children }) {
    return children ? <h2 className={styles.subHeader}>{children}</h2> : null;
}

HpSharedModuleSubHeader.propTypes = {
    children: PropTypes.node,
};

class HpSharedModuleContainer extends Component {
    static Header = HpSharedModuleHeader;

    static SubHeader = HpSharedModuleSubHeader;

    render() {
        return (
            <div
                data-tn={this.props.dataTn}
                className={classnames(
                    { [styles.addTopGap]: this.props.addTopGap },
                    this.props.className
                )}
            >
                {this.props.children}
            </div>
        );
    }
}

HpSharedModuleContainer.propTypes = {
    children: PropTypes.node,
    addTopGap: PropTypes.bool,
    className: PropTypes.string,
    dataTn: PropTypes.string,
};

HpSharedModuleContainer.defaultProp = {
    addTopGap: false,
    className: null,
    dataTn: '',
};

export { HpSharedModuleContainer };
